import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BankMutationKeys } from '../../../keys'
import {
	UpdatePaymentGatewayRequest,
	UpdatePaymentGatewayResponse,
} from '../../../type'
import { updatePaymentGateway } from '../../services'

interface UseMutationUpdatePaymentGatewayProps {
	payload: UpdatePaymentGatewayRequest
}

export default function useMutationUpdatePaymentGateway(
	props?: UseBaseMutationOptions<
		UpdatePaymentGatewayResponse,
		UseMutationUpdatePaymentGatewayProps
	>,
) {
	return useMutation({
		mutationKey: [BankMutationKeys.UpdatePaymentGateway],
		mutationFn: (params) => updatePaymentGateway(params.payload),
		...props,
	})
}
